import { getVersion } from "../../crud/auth.crud";
import store from "../store";
import { allMessages } from "../../../_metronic/i18n/I18nProvider";
import { alert } from 'devextreme/ui/dialog';
import ProtectorHelper from "../../router/Protector/ProtectorHelper";
import Common from '../../shared/common';
import { addWeeks } from 'date-fns';
import { defaultLandingPage } from "../ducks/preferences.duck";
import SystemHelper from "../../shared/systemHelper";

const globalSearchEnabled = process.env.REACT_APP_GLOBAL_SEARCH_ENABLED === "true";
const analyticsMenuGroup =() =>[

  { section: "NAVIGATION.ANALYTICS" },
  {
    title: "Power BI Reports",
    translate: "NAVIGATION.MENU.POWERBI_REPORTS",
    root: true,
    icon: "flaticon2-line-chart",
    page: "/reports/powerbi/reports",
    onClick: (e) => {
      SystemHelper.hubspotUpdateEvent("NAV_MENU_POWERBI_REPORTS");
    }
  },
  {
    title: "Power BI Registers",
    translate: "NAVIGATION.MENU.POWERBI_REGISTERS",
    root: true,
    icon: "flaticon2-indent-dots",
    page: "/reports/powerbi/registers",
    onClick: (e) => {
      SystemHelper.hubspotUpdateEvent("NAV_MENU_POWERBI_REGISTERS");
    }
  },
  {
    title: "Power BI Exports",
    icon: "flaticon2-file",
    translate: "REPORTS.MESSAGE.POWERBIEXPORTS",
    page: "/reports/powerbi/exports",
  },
  {
    title: "Downloads",
    translate: "NAVIGATION.MENU.DOWNLOADS",
    root: true,
    icon: "flaticon-download-1",
    bullet: "dot",
    submenu: [
      {
        title: "Aggregated Reports",
        translate: "NAVIGATION.MENU.AGGREGATE",
        page: "/downloads/aggregate",
        onClick: (e) => {
          SystemHelper.hubspotUpdateEvent("NAV_MENU_AGGREGATED_REPORTS");
        }
      },
    ],
  },
  {
    title: "Admin Reports",
    translate: "NAVIGATION.MENU.ADMIN_REPORTS",
    root: true,
    icon: "flaticon2-analytics-1",
    bullet: "dot",
    submenu: [
      {
        title: "System Users Report",
        translate: "NAVIGATION.MENU.ADMIN_REPORTS_SYSTEM_USER",
        root: false,
        page: "/reports/system-users",
      },
      {
        title: "Contract Users Report",
        translate: "NAVIGATION.MENU.ADMIN_REPORTS_CONTRACT_USER",
        page: "/reports/contract-users",
      },
      {
        title: "Contract Lead Users Report",
        translate: "NAVIGATION.MENU.ADMIN_REPORTS_CONTRACT_LEAD_USER",
        page: "/reports/contract-lead-users",
      }
    ]
  }
];
const contractDashboardMenuGroup = (prefix) => [
  { section: "NAVIGATION.MENU.CONTRACT" },
  {
    title: "DASHBOARD",
    translate: "NAVIGATION.MENU.DASHBOARD",
    root: true,
    icon: "flaticon2-analytics-2",
    page: prefix + "dashboard",
  },
  {
    title: "Generic Drafts",
    translate: "NAVIGATION.MENU.GENERIC_DRAFTS",
    root: true,
    icon: "flaticon2-mail-1",
    page: prefix + "generic-drafts",
  },
  {
    title: "Reports",
    translate: "NAVIGATION.MENU.REPORTS",
    root: true,
    icon: "flaticon2-poll-symbol",
    bullet: "dot",
    submenu: [
      {
        title: "Contract Health Check",
        translate: "NAVIGATION.MENU.CONTRACT_HEALTH",
        page: prefix + "reports/health",
      },
      {
        title: "Contract RAG",
        translate: "NAVIGATION.MENU.CONTRACT_RAG",
        page: prefix + "reports/rag",
      },
    ],
  },
];
const contractSettingMenuGroup = (prefix) => [
  {
    title: "Contract",
    translate: "NAVIGATION.MENU.CONTRACT",
    root: true,
    icon: "flaticon2-gear",
    bullet: "dot",
    alwaysExpand: true,
    submenu: [
      {
        title: "Overview",
        translate: "NAVIGATION.MENU.OVERVIEW",
        page: prefix + "settings/overview"
      },
      {
        title: "Contract users",
        translate: "NAVIGATION.MENU.CONTRACT_USERS",
        page: prefix + "settings/users",
      },
      {
        title: "Contract Email Recipients",
        translate: "NAVIGATION.MENU.CONTRACT_MAIL_RCP",
        page: prefix + "settings/email-recipients",
      },
      {
        title: "Contract template",
        translate: "NAVIGATION.MENU.CONTRACT_TEMPLATE",
        page: prefix + "settings/template",
      },
      {
        title: "Dates",
        translate: "NAVIGATION.MENU.CONTRACT_DATES",
        page: prefix + "settings/secondary-dates"
      },
      {
        title: "Amounts",
        translate: "NAVIGATION.MENU.CONTRACT_PRICES",
        page: prefix + "settings/secondary-prices"
      },
      {
        title: "Actions",
        translate: "NAVIGATION.MENU.CONTRACT_ACTIONS",
        page: prefix + "settings/actions"
      },
      {
        title: "Exports",
        translate: "CONTRACT.MENU.EXPORTS",
        page: prefix + "settings/exports",
      },
      {
        title: "Assets",
        translate: "NAVIGATION.MENU.ASSETS",
        page: prefix + "settings/assets",
      },
      {
        title: "Price Lists",
        translate: "NAVIGATION.MENU.PRICELISTS",
        page: prefix + "settings/price-list",
      },
      {
        title: "AI Settings",
        translate: "NAVIGATION.MENU.AI_SETTINGS",
        page: prefix + "settings/ai-settings",
      }
    ]
  }
];

const settingsMenuItems = (contractPrefix) => {
  const settingsGroupMenu = [{ section: "NAVIGATION.SETTINGS" }];
  if (contractPrefix) {
    settingsGroupMenu.push(...contractSettingMenuGroup(contractPrefix))
  }

  settingsGroupMenu.push(
    {
      title: "Companies",
      translate: "NAVIGATION.MENU.COMPANIES",
      root: false,
      icon: "flaticon2-world",
      page: "/admin/companies",
    },
    {
      title: "Projects",
      translate: "NAVIGATION.MENU.PROJECTS",
      root: false,
      icon: "flaticon2-folder",
      page: "/admin/projects",
    },
    {
      title: "Master",
      translate: "NAVIGATION.MENU.MASTER",
      root: true,
      icon: "flaticon2-console",
      submenu: [
        {
          title: "Master Workflows",
          translate: "NAVIGATION.MENU.MASTER_WORKFLOWS",
          page: "/admin/templates/master-workflows",
        },
        {
          title: "Master Templates",
          translate: "NAVIGATION.MENU.MASTER_TEMPLATES",
          page: "/admin/templates/master-templates",
        },
      ],
    },
    {
      title: "Users",
      translate: "NAVIGATION.MENU.USERS",
      root: false,
      icon: "flaticon2-group",
      submenu: [
        {
          title: "Manage System Users",
          translate: "NAVIGATION.MENU.MANAGE_SYSTEM_USERS",
          page: "/admin/users/manage-system-users",
        },
        {
          title: "Add User to Multiple Contracts",
          translate: "NAVIGATION.MENU.BULK_ADD_CONTRACT_USERS",
          page: "/admin/users/contract-add-bulk-users",
        }
      ],
    },
    {
      title: "System Settings",
      translate: "NAVIGATION.MENU.SYSTEM_SETTINGS",
      root: false,
      icon: "flaticon2-settings",
      page: "/admin/settings",
    },
    /* {
      title: "AI Settings",
      translate: "NAVIGATION.MENU.AI_SETTINGS",
      root: false,
      icon: "flaticon2-settings",
      page: "/admin/ai-settings",
    }, */
  );
  return settingsGroupMenu;
}
export default class MenuItemsHelper {
  static filterAccessAllowed = (items, userProfile, contract, contractUser) => {
    const retList = [];
    let section = null;
    items.forEach(item => {
      if (item.section) {
        section = item;
      }
      else if (item.page && ProtectorHelper.isPathAllowed(item.page, userProfile, contract, contractUser)) {
        retList.push(item)
      }
      else if (item.submenu) {
        item.submenu = MenuItemsHelper.filterAccessAllowed(item.submenu, userProfile, contract, contractUser)
        if (item.submenu && item.submenu.length > 0) {
          retList.push(item)
        }
      }
    });
    if (retList.length > 0 && section) {
      retList.unshift(section);
    }
    return retList;
  }
  static getMainMenuItems = (userProfile, landingpage, contract, template, contractUser) => {
    // const allowedPaths = ProtectorHelper.getAllowedPaths(userProfile);
    let asideItems = [];
    if (landingpage && landingpage !== "/" && landingpage !== defaultLandingPage) {
      asideItems.push(
        {
          title: "HOME",
          translate: "NAVIGATION.MENU.HOME",
          root: true,
          icon: "flaticon2-architecture-and-city",
          page: landingpage,
        },
      );
    }
    asideItems.push(
      {
        title: "CONTRACTS",
        translate: "NAVIGATION.MENU.CONTRACTS",
        root: true,
        icon: asideItems.length ? "flaticon2-layers" : "flaticon2-architecture-and-city",
        page: "/contracts",
      },
      {
        title: "ACTIONS",
        translate: "NAVIGATION.MENU.ACTIONS",
        root: true,
        icon: "flaticon2-check-mark",
        page: "/actions",
        onClick: (e) => {
          SystemHelper.hubspotUpdateEvent("NAV_MENU_ACTIONS");
        }
      }
    );

    if (globalSearchEnabled) {
      asideItems.push({
        title: "SEARCH",
        translate: "NAVIGATION.MENU.SEARCH",
        root: true,
        icon: "flaticon2-search-1",
        page: "/search",
        onClick: (e) => {
          SystemHelper.hubspotUpdateEvent("NAV_MENU_SEARCH");
        }
      });
    }

    const copyOfAnalyticsMenuGroup = analyticsMenuGroup();
    const analyticsMenuItemsFiltered = MenuItemsHelper.filterAccessAllowed(copyOfAnalyticsMenuGroup, userProfile);
    asideItems.push(...analyticsMenuItemsFiltered);


    let contractPrefix = '';
    if (contract && contract.contractid) {
      contractPrefix = "/contract/" + contract.contractid + "/";

      const contractDashboardMenuItems = contractDashboardMenuGroup(contractPrefix);
      const contractDashboardMenuItemsFiltered = MenuItemsHelper.filterAccessAllowed(contractDashboardMenuItems, userProfile, contract, contractUser);
      asideItems.push(...contractDashboardMenuItemsFiltered);

      //NO ADDITIONAL ACCESS CHECK 
      asideItems.push(...MenuItemsHelper.getContractWorkflowMenuItems(template));
    }

    const settingMenuItems = settingsMenuItems(contractPrefix);
    const settingMenuItemsFiltered = MenuItemsHelper.filterAccessAllowed(settingMenuItems, userProfile, contract, contractUser);
    asideItems.push(...settingMenuItemsFiltered);

    return asideItems;
  }
  static getContractWorkflowMenuItems = (template) => {
    let workflowMenuItems = template.workflowGroups.map((workFlowGroupItem) => {
      const mappedSubmenu = workFlowGroupItem.workflows.map((workflowItem) => {
        return {
          title: workflowItem.title,
          page: workflowItem.paths.defaultPath,
        };
      });

      return {
        title: workFlowGroupItem.title,
        root: true,
        icon: workFlowGroupItem.icon,
        bullet: "dot",
        submenu: mappedSubmenu,
      };
    });

    if (workflowMenuItems.length > 0) {
      //   const testGroup = [];
      //   testGroup.push({ section: "NAVIGATION.WORKFLOWS" },
      //   {
      //     title: 'workflows',
      //     root: true,
      //     icon: 'flaticon2-world',
      //     // bullet: "dot",
      //     submenu: workflowMenuItems,
      //   }
      //   )
      //   return testGroup;
      //ADD HEADER IF ITEMS EXIST
      workflowMenuItems.unshift({ section: "NAVIGATION.WORKFLOWS" })
    }
    return workflowMenuItems;
  }

  static getSmartLinkItems = (links) => {
    let smartLinkItems = [{ section: "NAVIGATION.SMART_LINKS" }];

    if (links.length) {
      // smartLinkItems = 

      links.map((item) => {
        return smartLinkItems.push({
          title: item.Name,
          root: true,
          icon: "flaticon-questions-circular-button",
          page: item.URL,
          target: item.Target,
          onClick: (e) => {
            if (item.URL.startsWith("https://builtintelligence.zendesk.com/hc/en-gb/categories/360001721397-Product-Feature-Updates")) {
              SystemHelper.hubspotUpdateEvent("NAV_MENU_NEW_FEATURES");
            }
            else if(item.URL.startsWith("https://builtintelligence.zendesk.com/hc/en-gb")) {
              SystemHelper.hubspotUpdateEvent("NAV_MENU_SUPPORT");
            }
            else if(item.URL.startsWith("https://reachback.builtintelligence.com")) {
              SystemHelper.hubspotUpdateEvent("NAV_MENU_REACHBACK");
            }
            else if(item.URL.startsWith("https://forms.monday.com/forms/127689b3d2dd90ac577b14720d452100")) {
              SystemHelper.hubspotUpdateEvent("NAV_MENU_ENHANCEMENT_REQUEST");
            }
          }
        });
      });
    }
    const aboutOnClick = async (e) => {
      e.preventDefault();
      let apiVersion = "";
      try {
        const response = await getVersion();
        apiVersion = response.data.apiVersion;
      } catch (error) {
        apiVersion = "(Error fetching API version!)"
      }


      const storeState = store.getState();
      const message = `${allMessages[storeState.i18n.lang].SYSTEM_UI_VERSION}: ${process.env.REACT_APP_VERSION}<br>${allMessages[storeState.i18n.lang].SYSTEM_API_VERSION}: ${apiVersion}`;
      await alert(`<div style="max-width:50vw;min-width:300px">${message}</div>`, allMessages[storeState.i18n.lang].SYSTEM_VERSION_TITLE);
      // store.dispatch({ type: applicationDuck.actionTypes.APPLICATION_SET_SYSTEM_MESSAGE, payload: { title: allMessages[storeState.i18n.lang].SYSTEM_VERSION_TITLE, message: message } });
    }

    smartLinkItems.push({ title: 'About', root: true, icon: 'flaticon-questions-circular-button', page: '#', target: '#', onClick: aboutOnClick })
    if (process.env.REACT_APP_ACCESSIBE_ENABLED === "true") {
      smartLinkItems.push({ title: 'Accessibility', root: true, icon: 'flaticon-questions-circular-button', page: '#', target: '#', onClick: (e) => e.preventDefault(), attributes: { "data-acsb-custom-trigger": "true" } });
    }
    return smartLinkItems;
  }

  static getContractQuickActionsMenuItems = (template) => {
    let quickActionsMenu = [];
    if (template.workflowGroups.length > 0) {
      template.workflowGroups.forEach((workFlowGroupItem) => {
        if (workFlowGroupItem.workflows.length > 0) {
          workFlowGroupItem.workflows.forEach((workflowItem) => {
            if ((workflowItem.userFilters.mainNotice || {}).createAllowed && workflowItem.paths.createPath) {
              let targetClauses = [];

              // 1. Primary Check: Standard workflowItem.clauses
              if (workflowItem.clauses && workflowItem.clauses.length > 0) {
                targetClauses = workflowItem.clauses;
              }

              // 2. Fallback: Search keys in 'fields' that contain the word "Type"
              else if (workflowItem.fields) {
                // Get all keys (e.g., ["Status", "CompensationType", "Date"])
                const fieldKeys = Object.keys(workflowItem.fields);

                // Find the first key that includes "Type" and has clauses
                const typeKey = fieldKeys.find(key =>
                  key.includes('Type') &&
                  workflowItem.fields[key].clauses?.length > 0
                );

                if (typeKey) {
                  targetClauses = workflowItem.fields[typeKey].clauses;
                } else {
                  //FD-12993
                  //When grouping clauses by Workflow under the Create New via Clause Type button
                  // (and Assign a Generic Draft wizard) if a workflow exists but clause list is blank
                  // then Page Title Should appear in that group as a selectable clause
                  var clause = {
                    display: workflowItem.pageTitle
                  };

                  targetClauses = [clause];
                }
              }

              quickActionsMenu.push({
                title: workflowItem.pageTitle,
                icon: workFlowGroupItem.icon,
                page: workflowItem.paths.createPath,
                reftype: workflowItem.config.referenceType,
                wfgid: workFlowGroupItem.id,
                wfid: workflowItem.id,
                // Add the clauses property. If targetClauses is empty, it will be an empty array.
                clauses: targetClauses
              });
            }
          });
        }
      });
    }
    quickActionsMenu = quickActionsMenu.sort((a, b) => a.title.localeCompare(b.title));
    return quickActionsMenu;
  }
  static getMinimumRAGColor = (objectCollection) => {
    let minRAGColor = 3;
    for (let index = 0; index < objectCollection.length; index++) {
      if (objectCollection[index].RAGColor < minRAGColor) {
        minRAGColor = objectCollection[index].RAGColor;
      }
      if (minRAGColor === 1) {
        break;
      }
    }
    return minRAGColor;
  }
  static getBadgeColorForRAGColor = (colorIndex, libName) => {
    switch (colorIndex) {
      case 0:
        return "secondary";
      case 1:
        if (libName === "mui") {
          return "error";
        }
        else if (libName === "bootstrap") {
          return "danger";
        }
        throw Error("Unknown library name:" + libName);
      case 2:
        return "warning";
      case 3:
        return "success";
      default:
        return "success";
    }
  }
  static getContractManualActions = (rawManualActions, template) => {
    const mappedActionItems = rawManualActions.map(action => {
      const actionDate = new Date(action.duedate);
      let RAGColor = 3;
      if (actionDate < new Date()) {
        RAGColor = 1;
      }
      else if (actionDate < addWeeks(new Date(), 1)) {
        RAGColor = 2;
      }
      else {
        RAGColor = 3;
      }
      return {
        ...action,
        duedate: actionDate,
        RAGColor
      }
    }
    );
    const manualActionGroupByParty = Common.GroupBy(mappedActionItems, 'ownerparty');
    const manualActionsObj = {
      lastLoadedEpochTime: new Date().getTime(),
      items: mappedActionItems,
      RAGColor: this.getMinimumRAGColor(mappedActionItems),
      RAGColor_1_Count: mappedActionItems.filter(x => x.RAGColor === 1).length,
      RAGColor_2_Count: mappedActionItems.filter(x => x.RAGColor === 2).length,
      RAGColor_3_Count: mappedActionItems.filter(x => x.RAGColor === 3).length,
      SUPPLIER: {
        items: manualActionGroupByParty["1"] ?? [],
        RAGColor: this.getMinimumRAGColor(manualActionGroupByParty["1"] ?? [])
      },
      PM: {
        items: manualActionGroupByParty["2"] ?? [],
        RAGColor: this.getMinimumRAGColor(manualActionGroupByParty["2"] ?? [])
      },
      SUPERVISOR: {
        items: manualActionGroupByParty["3"] ?? [],
        RAGColor: this.getMinimumRAGColor(manualActionGroupByParty["3"] ?? [])
      },
      CLIENT: {
        items: manualActionGroupByParty["4"] ?? [],
        RAGColor: this.getMinimumRAGColor(manualActionGroupByParty["4"] ?? [])
      },
    }

    Object.keys(manualActionsObj).forEach(pty => {
      const ptyItems = manualActionsObj[pty].items;
      if (ptyItems) {
        const manualActionGroupByCategory = ptyItems ? Common.GroupBy(ptyItems, 'groupcategory') : {};
        manualActionsObj[pty].GRP_1 = {
          items: manualActionGroupByCategory["1"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["1"] ?? [])
        }
        manualActionsObj[pty].GRP_2 = {
          items: manualActionGroupByCategory["2"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["2"] ?? [])
        }
        manualActionsObj[pty].GRP_3 = {
          items: manualActionGroupByCategory["3"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["3"] ?? [])
        }
        manualActionsObj[pty].GRP_4 = {
          items: manualActionGroupByCategory["4"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["4"] ?? [])
        }
        manualActionsObj[pty].GRP_5 = {
          items: manualActionGroupByCategory["5"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["5"] ?? [])
        }
        manualActionsObj[pty].GRP_6 = {
          items: manualActionGroupByCategory["6"] ?? [],
          RAGColor: this.getMinimumRAGColor(manualActionGroupByCategory["6"] ?? [])
        }

        const subGroups1 = Common.GroupBy(manualActionsObj[pty].GRP_1.items, 'type');
        manualActionsObj[pty].GRP_1.subGroups = [];
        Object.keys(subGroups1).forEach(type => {
          manualActionsObj[pty].GRP_1.subGroups.push({
            title: template.availableActionTypesTypeDisplayObj[type],
            workflow: null,
            items: subGroups1[type],
            RAGColor: this.getMinimumRAGColor(subGroups1[type])
          })
        })

        const subGroups2 = Common.GroupBy(manualActionsObj[pty].GRP_2.items, 'resolvingworkflowid');
        manualActionsObj[pty].GRP_2.subGroups = [];
        Object.keys(subGroups2).forEach(wfid => {
          manualActionsObj[pty].GRP_2.subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: subGroups2[wfid],
            RAGColor: this.getMinimumRAGColor(subGroups2[wfid])
          })
        });
        manualActionsObj[pty].GRP_2.subGroups.sort((a, b) => a.workflow.groupID - b.workflow.groupID)

        const subGroups3 = Common.GroupBy(manualActionsObj[pty].GRP_3.items, 'resolvingworkflowid');
        manualActionsObj[pty].GRP_3.subGroups = [];
        Object.keys(subGroups3).forEach(wfid => {
          manualActionsObj[pty].GRP_3.subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: subGroups3[wfid],
            RAGColor: this.getMinimumRAGColor(subGroups3[wfid])
          })
        });
        manualActionsObj[pty].GRP_3.subGroups.sort((a, b) => a.workflow.groupID - b.workflow.groupID)

        const subGroups4 = Common.GroupBy(manualActionsObj[pty].GRP_4.items, 'resolvingworkflowid');
        manualActionsObj[pty].GRP_4.subGroups = [];
        Object.keys(subGroups4).forEach(wfid => {
          manualActionsObj[pty].GRP_4.subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: subGroups4[wfid],
            RAGColor: this.getMinimumRAGColor(subGroups4[wfid])
          })
        });
        manualActionsObj[pty].GRP_4.subGroups.sort((a, b) => a.workflow.groupID - b.workflow.groupID)

        const subGroups5 = Common.GroupBy(manualActionsObj[pty].GRP_5.items, 'resolvingworkflowid');
        manualActionsObj[pty].GRP_5.subGroups = [];
        Object.keys(subGroups5).forEach(wfid => {
          manualActionsObj[pty].GRP_5.subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: subGroups5[wfid],
            RAGColor: this.getMinimumRAGColor(subGroups5[wfid])
          })
        });
        manualActionsObj[pty].GRP_5.subGroups.sort((a, b) => a.workflow.groupID - b.workflow.groupID)

        const subGroups6 = Common.GroupBy(manualActionsObj[pty].GRP_6.items, 'resolvingworkflowid');
        manualActionsObj[pty].GRP_6.subGroups = [];
        Object.keys(subGroups6).forEach(wfid => {
          manualActionsObj[pty].GRP_6.subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: subGroups6[wfid],
            RAGColor: this.getMinimumRAGColor(subGroups6[wfid])
          })
        });

      }
    });
    return manualActionsObj;
  }
  static getContractPendingDrafts = (rawPendingDrafts, template) => {
    const mappedDraftItems = rawPendingDrafts
      .filter(item => {
        //FILTER OUT IF VIEW DRAFTS NOT ALLOWED
        let wf = template.workflowsQA[item.workflowid];
        if (item.parentrecordid) {
          return wf?.userFilters?.quoteMainNotice?.createQuoteAllowed || wf?.userFilters?.quoteMainNotice?.communicateQuoteAllowed;
        }
        else {
          return wf?.userFilters?.mainNotice?.viewDraftAllowed;
        }
      })
      .map(item => {
        return {
          ...item,
          RAGColor: 0,
          groupcategory: 0,
          type: 'DRAFT'
        }
      }
      );
    const pendingDraftsGroupByParty = Common.GroupBy(mappedDraftItems, 'notifyingparty');
    const pendingDraftsObj = {
      lastLoadedEpochTime: new Date().getTime(),
      items: mappedDraftItems,
      SUPPLIER: {
        items: pendingDraftsGroupByParty["1"] ?? [],
        RAGColor: 0
      },
      PM: {
        items: pendingDraftsGroupByParty["2"] ?? [],
        RAGColor: 0
      },
      SUPERVISOR: {
        items: pendingDraftsGroupByParty["3"] ?? [],
        RAGColor: 0
      },
      CLIENT: {
        items: pendingDraftsGroupByParty["4"] ?? [],
        RAGColor: 0
      },
    }

    Object.keys(pendingDraftsObj).forEach(pty => {
      const ptyItems = pendingDraftsObj[pty].items;
      if (ptyItems) {
        const pendingDraftsGroupByWorkflow = Common.GroupBy(ptyItems, 'workflowid');
        pendingDraftsObj[pty].subGroups = [];
        Object.keys(pendingDraftsGroupByWorkflow).forEach(wfid => {
          pendingDraftsObj[pty].subGroups.push({
            title: template.workflowsQA[wfid].pageTitle,
            workflow: JSON.parse(JSON.stringify(template.workflowsQA[wfid])),
            items: pendingDraftsGroupByWorkflow[wfid],
            RAGColor: 0
          })
        });
        pendingDraftsObj[pty].subGroups.sort((a, b) => a.workflow.groupID - b.workflow.groupID);
      }
    });
    return pendingDraftsObj;
  }
}
